<template>
  <div v-if="show" class="block-overlay">
    <section class="timesup">
      <div class="notice">
        <div class="title_oh">
          <h1>Uh-oh!</h1>
        </div>
        <div class="subtitle_oh">
          <h3 class="typing">The cookie's all gone!</h3>
        </div>
      </div>

      <div class="flags"></div>
      <div class="balloons"></div>
    </section>
    <!-- Footer -->
    <footer>
      <div class="copyright">
        <p>© 2023 Developed by YuChing Su & Haoyun Wu</p>
      </div>
    </footer>
  </div>
</template>
  
  <script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
  
<style scoped>
.block-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 1000; /* 確保遮罩始終在其他元素的頂部 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* --------------------- time's up ---------------------*/
.timesup {
  background-image: url(../assets/images/timesup_bg.svg);
  height: 100vh;
  width: 100vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.flags {
  background-image: url(../assets/images/flags.svg);
  position: absolute;
  right: 0;
  top: -30px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 28%; /* Adjust this value based on your needs */
}

.balloons {
  background-image: url(../assets/images/balloons.svg);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom left;
  background-size: 22%; /* Adjust this value based on your needs */
}

.notice {
  position: absolute;
  left: 22%;
  top: 12%;
}

.title_oh h1 {
  font-size: 2.7em;
  text-align: left;
  transform: rotate(-20deg);
  line-height: 50px;
}

.subtitle_oh h3 {
  font-size: 1.5em;
  text-align: left;
  transform: rotate(-12deg);
  line-height: 30px;
}

/* -------------- typing ------------- */
.typing {
  overflow: hidden;
  white-space: nowrap;
  animation: typing 1.5s steps(30, end);
}

/* Typing animation */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
  